import { render, staticRenderFns } from "./keyword-manage.vue?vue&type=template&id=6054fbda&"
import script from "./keyword-manage.vue?vue&type=script&lang=js&"
export * from "./keyword-manage.vue?vue&type=script&lang=js&"
import style0 from "./keyword-manage.vue?vue&type=style&index=0&id=6054fbda&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports